import React from 'react';
export function SolutionSection() {
  return <section data-id="element-337">
      <div className="max-w-4xl mx-auto text-center" data-id="element-338">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#A855F7]/50 text-[#A855F7] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-339">
          🏆 VÉRTICE DIGITAL™ MEGAPACK PILATES LISTO
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-6" data-id="element-340">
          6 Tomos + 6 Bonos — Inicial → Especialista
          <br data-id="element-341" />
          <span className="text-[#A855F7]" data-id="element-342">300+ páginas — Todo resuelto.</span>
        </h2>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-10 max-w-2xl mt-12" data-id="element-343">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-344">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => {
            const labels = ['Reformer', 'Mat & Props', 'Clínico', 'Poblaciones', 'Flow', 'Negocio'];
            return <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
              backgroundColor: color,
              border: '2px solid #A855F7'
            }} data-id="element-345">
                  <span className="text-white text-xs font-bold" style={{
                textShadow: '0 1px 3px rgba(0,0,0,0.8)'
              }} data-id="element-346">
                    {labels[i]}
                  </span>
                </div>;
          })}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#A855F7] text-white font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-347">
            💪 6 TOMOS COMPLETOS
          </div>
        </div>
      </div>
    </section>;
}